import React from 'react';
import {connect} from 'react-redux';
import { concatStudentNames } from '../../../../../utilities/common';
import {isEmpty} from '../../../../../utilities/validation';
var getLang = function () {
  var l = localStorage.getItem('stuLang');
  return l ? l : 'en';
};

var t = function (enText, esText) {
  var lang = getLang();
  return lang === 'es' ? esText : enText;
};

var translateAssessmentName = function(name) {
  if (!name) return '';

  var lower = name.toLowerCase();

  if (lower === 'module guide') return 'Guía del módulo';
  if (lower === 'post test') return 'Prueba final';
  if (lower === 'engagement survey') return 'Encuesta de participación';
  if (lower.indexOf('pop quiz') !== -1) {
    return name.replace('Pop Quiz', 'Cuestionario');
  }
  if (lower.indexOf('rca') !== -1) {
    return name; // keep RCA as-is
  }

  return name;
};

class PostAssessmentPage extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {name='', currentMyAssignment = {}, role = '',
            points_possible=0, totalPointsAchieved=0, grades={}} = this.props;
        console.log('engagement survey', this.props);
        var users = this.props.users;
        if (!Array.isArray(users)) {
            users = Object.values(users || {});
        }
        console.log(users);
        let studentNames = '';
        if (!isEmpty(users) && !isEmpty(grades) && users.length > 0) {
            studentNames = concatStudentNames(users);
        }
        // console.log(grades);
        const poinstPossible = localStorage.getItem('pointpossiblefromapi');
        // console.log(grades);
        // console.log(poinstPossible);
        // console.log(poinstPossible);


        if(!isEmpty(grades) && grades[0].points != "" && grades[0].points != undefined && grades[0].points > poinstPossible && this.props.name != 'Engagement Survey'){
            grades[0].points = Math.round(grades[0].points);
            // console.log(grades[0].points);
        }

        if(!isEmpty(grades) && grades[1] != null && grades[1] != undefined && grades[1].points != ""  && grades[1].points > poinstPossible && this.props.name != 'Engagement Survey'){
            grades[1].points = Math.round(grades[1].points)
            // console.log(grades[1].points);
        }


        if(!isEmpty(grades) && grades[0].points != "" && grades[0].points != undefined && this.props.name != 'Engagement Survey'){
            grades[0].points = parseFloat(grades[0].points).toFixed(1);

            const decimalStr = grades[0].points.toString().split('.')[1];
            // console.log(decimalStr);
            if(decimalStr == 0){
                grades[0].points = parseFloat(grades[0].points).toFixed();
            }
            // console.log(grades[0].points);
        }

        if(!isEmpty(grades) && grades[1] != null && grades[1] != undefined && grades[1].points != "" && grades[1].points != undefined && this.props.name != 'Engagement Survey'){
            grades[1].points = parseFloat(grades[1].points).toFixed(1);

            const decimalStr = grades[1].points.toString().split('.')[1];
            // console.log(decimalStr);
            if(decimalStr == 0){
                grades[1].points = parseFloat(grades[1].points).toFixed();
            }

            // console.log(grades[1].points);
        }

        if(!isEmpty(grades) && grades[0].points != "" && grades[0].points != undefined && Math.round(grades[0].points) == poinstPossible && this.props.name != 'Engagement Survey'){
            grades[0].points = grades[0].points;
            // console.log(grades[0].points+"rerere");
        }



        return (
            <div>
                <div className="node assessment-top-container">
                    {
                        (!isEmpty(users) && !isEmpty(grades) && users.length > 0 && grades.length > 1 && this.props.name != 'Engagement Survey') &&
                        <div>
                            <h2>{studentNames}, {t('you have finished the','has terminado el')} {getLang() === 'es' ? translateAssessmentName(name) : name}.</h2>
                            <h2>{users[0].userName} {t('received','recibido')} {grades[0].points} out of {poinstPossible} points.</h2>
                            <h2>{users[1].userName} {t('received','recibido')} {grades[1].points} out of {poinstPossible} points.</h2>
                        </div>
                    }
                    {
                        (!isEmpty(users) && !isEmpty(grades) && users.length > 0 && grades.length < 2 && this.props.name != 'Engagement Survey') &&
                        <div>
                            <h2>{studentNames}, {t('you have finished the','has terminado el')} {getLang() === 'es' ? translateAssessmentName(name) : name}.</h2>
                            <h2>{t('You received','Has recibido')} {grades[0].points} {t('out of','fuera de')} {poinstPossible} {t('points.','puntos.')}</h2>
                        </div>
                        }

                        {
                        (this.props.name == 'Engagement Survey' && this.props.userAssessmentProgress &&
                            this.props.userAssessmentProgress[0] &&
                            this.props.userAssessmentProgress[0].progress &&
                            this.props.userAssessmentProgress[0].progress.feedback != 1)?(
                            <div>
                            <h2>{studentNames}, {t('Thank you for giving your  feedback.','Gracias por darnos tu opinión.')} </h2>
                            <h2>{t('Please click continue to return to your  Star Academy  journey!','¡Por favor, haz clic en continuar para volver a tu aventura en Star Academy!')}</h2>

                        </div>
                        ):(
                            <h2>{t('Please click Continue to begin the session activities.','Por favor, haga clic en Continuar para comenzar las actividades de la sesión.')}</h2>
                        )
                        }
                </div>

                <div className="node assessment-bottom-container">
                    <button className={t('assessment-cancel','assessment-cancel-spanish')} disabled="disabled" />
                    <button className={t('assessment-continue','assessment-continue-spanish')} onClick={this.props.nextPage} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // console.log(state);
    const {currentMyAssignment = {}} = state.auth.assignment;
    const {users = {}, user = {}} = state.auth;
    return {
        currentMyAssignment,
        role: users[0].role,
        users: users
    };
};

const PostAssessment = connect(
    mapStateToProps,
    null
)(PostAssessmentPage);

export default PostAssessment;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/assessment/post-assessment.js